<style lang="less" scoped>
.ol-popup {position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 0px;}
.ol-popup:before {border-top-color: #cccccc;border-width: 11px;left: 48px;margin-left: -11px;}
.popup-content {width: 300px;color: #d6d4d4; font-family: Microsoft YaH;text-align: center;padding: 0 15px;height: 110px;}
.ol-popup-closer:after {content: "✖";}
.title{width: 300px; height: 30px;background: rgba(33, 185, 191, 0.6);margin: 0;display: flex;justify-content: space-between;line-height: 30px;padding: 0 15px;color: #fff;}
.inp {margin: 10px 0px;}
.el-button {border-radius: 20px;border: solid 1px #3c818d;}
.el-button--primary {color: #FFF;background-color: rgba(33, 185, 191, 0.6);}
.el-button--default {color: #FFF;background: rgba(10, 17, 43, 0.4);}
</style>

<template>
  <div>
    <div id="popup" class="ol-popup" v-show="flag">
      <p class="title">
        <span>相关操作</span>
        <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
      </p>
      <div id="popup-content" class="popup-content">
        <el-input v-model="latitude" class="inp"></el-input>
        <el-button type="primary" @click="onSave">保存</el-button>
        <el-button type="primary" @click="onDelete">删除</el-button>
        <el-button @click="closePul(false)">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import 'ol/ol.css'
import Overlay from 'ol/Overlay'
import {mapState} from 'vuex'
import Measure from './Measure'
export default {
  mixins: [Measure],
  data()
  {
    return {
      map: null,
      overlay: null,
      flag: false,
      latitude: '',
      params: {},
      markType: '',
      LayernarData: [],
      pointAry: []
    }
  },
  computed: {
    ...mapState({
      curID: state => state.Marktype
    })
  },
  watch: {
    curID:
    {
      handler(nval, oval)
      {
        this.markType = nval
      },
      immediate: true
    }
  },
  methods:
  {
    /**
     * @method
     * @params  map {} 地图信息
     * @params  params {Object} 属性信息
     * @params  evt 点击事件参数
     */
    propertiesview(map, params, wfsVectorLayer, evt)
    {
      let _that = this
      _that.LayernarData = []
      _that.LayernarData.push(wfsVectorLayer)
      _that.flag = true
      _that.latitude = params.text
      _that.params = params
      // 使用变量存储弹窗所需的 DOM 对象
      var container = document.getElementById('popup')
      var closer = document.getElementById('popup-closer')
      // 创建一个弹窗 Overlay 对象
      _that.overlay = new Overlay({
        element: container, //绑定 Overlay 对象和 DOM 对象的
        autoPan: true, // 定义弹出窗口在边缘点击时候可能不完整 设置自动平移效果
        autoPanAnimation: {
          duration: 250 //自动平移效果的动画时间 9毫秒
        }
      })
      // 将弹窗添加到 map 地图中
      map.addOverlay(_that.overlay)
      _that.overlay.setPosition([params.locationpoine[0], params.locationpoine[1]]) //把 overlay 显示到指定的 x,y坐标
      /**
      * 为弹窗添加一个响应关闭的函数
      */
      closer.onclick = function()
      {
        _that.overlay.setPosition(undefined)
        closer.blur()
        return false
      }
    },
    closerFrame()
    {
      var closer = document.getElementById('popup-closer')
      if (this.overlay)
        this.overlay.setPosition(undefined)
      closer.blur()
      return false
    },
    closePul(show)
    {
      this.flag = show
    },
    onSave()
    {
      if (localStorage.getItem('username'))
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${localStorage.getItem('username')}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length === 1)
          {
            let obj = {
              cmd: 'add',
              _major: 11,
              _minor: 102,
              retAtt: 1,
              name: ret[0].passport,  //用户名
              prjid: this.markType,  //类型
              regcoor: this.params.locationpoine.toString(), //坐标
              username: localStorage.getItem('username'),
              content: this.params.text  //信息
            }
            window.post.getPost(obj).then((ret1) =>
            {
              if (ret1.ret === 0)
                this.flag = false
            })
          }
        })
      }
      else
        this.$message({message: '请您先到首页登录后再进行此操作', type: 'warning', customClass: 'mzindex'})
    },
    onDelete()
    {
      this.LayernarData[0].getSource().clear()
      window.map.removeLayer(this.LayernarData[0])
      this.flag = false
      this.LayernarData = []
      if (this.LayernarData.length === 0)
        this.deleteMark()
    },
    getpointAry(obj)
    {
      this.pointAry = obj
    },
    deleteMark()
    {
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Operation.vue